/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_VolumeInputs */

const cs_reports_col_volume = /** @type {(inputs: Reports_Col_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objem`)
};

const en_reports_col_volume = /** @type {(inputs: Reports_Col_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Reports_Col_VolumeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_volume = /** @type {((inputs?: Reports_Col_VolumeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_VolumeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_volume(inputs)
	return cs_reports_col_volume(inputs)
});